const groupSelect = document.querySelector('.js-products__group');
if (groupSelect) {
    groupSelect.addEventListener('change', function() {
        getProductsData();
    });
}

const allergiesCheckbox = document.querySelectorAll('.js-products__allergies');
if (allergiesCheckbox) {
    for (let i = 0; i < allergiesCheckbox.length; i++) {
        allergiesCheckbox[i].addEventListener('change', function() {
            getProductsData();
        });
    }
}

const urlParams = new URLSearchParams(window.location.search);
if (urlParams) {
    window.addEventListener('load', function() {
        if (urlParams && urlParams.get('openModal')) {
            if (typeof laroute.routes == 'undefined') {// eslint-disable-line no-undef
                let counter = 0;
                const interval = setInterval(function() {
                    counter += 1;
                    if (typeof laroute.routes != 'undefined') {// eslint-disable-line no-undef
                        openProductRequestModal();
                        clearInterval(interval);
                    }
                    if (counter == 20) {
                        clearInterval(interval);
                    }
                }, 1000);
            } else {
                openProductRequestModal();
            }
        }
    });
}

function openProductRequestModal() {
    const productId = urlParams.get('openModal');
    const productArticle = document.querySelector('[data-product-id="' + productId + '"]');
    if (productArticle) {
        if (productArticle.querySelector('.js-product__btn-request')) {
            productArticle.querySelector('.js-product__btn-request').click();
        } else {
            // no request btn found, scroll to element
            window.scrollTo({
                behavior: 'smooth',
                left: 0,
                top: productArticle.offsetTop + productArticle.offsetHeight
            });
        }

        window.history.pushState({}, document.title, location.pathname);
    }
}

function getProductsData() {
    const locale = document.querySelector('body').dataset.locale;
    let allergies = '';
    let group = '';
    for (let i = 0; i < allergiesCheckbox.length; i++) {
        if (allergiesCheckbox[i].checked) {
            allergies = allergies + 'allergies[]=' + allergiesCheckbox[i].value + '&';
        }
    }
    group = 'group=' + groupSelect.value;
    const url = '/' + locale + laroute.route('site.products.data.index') + '?' + allergies + group;// eslint-disable-line no-undef

    // Do request
    const request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.onload = function() {
        const productList = document.querySelector('.js-products__list');
        if (this.status >= 200 && this.status < 400) {
            window.history.replaceState(
                null,
                null,
                productList.dataset.route + '?' + allergies + group
            );
            document.getElementById('productsWrapper').innerHTML = this.response;
        }
    };
    request.send();
}

/**
 * @description - close the request modal
 */
function closeRequestModal() {
    const overlay = document.querySelector('.js-overlay');
    const modal = document.querySelector('.js-request');
    const modal2 = document.querySelector('.js-product-info-modal');

    overlay.classList.remove('c-overlay--active');
    modal.classList.remove('c-request--active');
    modal2.classList.remove('c-request--active');

    document.querySelector('.js-request__btn-send-aside').style.display = 'block';
    document.querySelector('.js-product-add-response-message').style.display = 'none';
}

const btnRequestClose = document.querySelectorAll('.js-request__btn-close');

if (btnRequestClose.length > 0) {
    btnRequestClose.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            closeRequestModal();
        });
    });
}

/**
 * @description - open the request modal
 * @param {String} productName
 * @param {String} productType
 * @param {String} productId
 */
function openRequestModal(productName, productType, productId) {
    const overlay = document.querySelector('.js-overlay');
    const modal = document.querySelector('.js-request');
    const productNameHolder = modal.querySelector('.js-request__product-name');
    document.querySelector('.js-request__btn-send-aside').style.display = 'none';
    document.querySelector('.js-request-modal').style.display = 'block';
    document.querySelector('.js-request-added-modal').style.display = 'none';
    document.querySelector('.js-request-send-modal').style.display = 'none';
    document.querySelector('.js-request-success-modal').style.display = 'none';

    let topPosition = (window.pageYOffset || document.documentElement.scrollTop)
        + (window.innerHeight / 2 - (modal.offsetHeight / 2));

    if (window.innerWidth <= 870) {
        topPosition = (window.pageYOffset || document.documentElement.scrollTop);
    }

    modal.style.top = topPosition + 'px';

    overlay.classList.add('c-overlay--active');
    modal.classList.add('c-request--active');
    if (productName) {
        productNameHolder.innerHTML = productName;
    }

    if (productType) {
        modal.dataset.productType = productType;
    }
    if (productId) {
        modal.dataset.productId = productId;
    }
}


/**
 * @description - Add products to request
 */

const btnsAddProduct = document.querySelectorAll('.js-product__btn-request');

if (btnsAddProduct.length > 0) {
    btnsAddProduct.forEach((btn) => {
        addProductClick(btn);
    });
}

function addProductClick(btn) {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        const productName = btn.closest('.js-product').dataset.productName;
        const productType = btn.closest('.js-product').dataset.productType;
        const productId = btn.closest('.js-product').dataset.productId;

        // Do request
        const request = new XMLHttpRequest();
        request.open(
            'GET',
            laroute.route('site.request.products.get', { product: productId }), // eslint-disable-line no-undef
            true
        );
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                const response = JSON.parse(this.response);
                if (response.image) {
                    document.querySelector('.js-popup-product-image').src = response.image;
                    document.querySelector('.js-popup-product-image').style.display = 'block';
                } else {
                    document.querySelector('.js-popup-product-image').style.display = 'none';
                }

                const tasteSelect = document.querySelector('.js-request__product-flavour');
                if (response.tastes && response.tastes.length) {
                    const tastes = response.tastes;
                    removeOptions(tasteSelect);
                    tasteSelect.required = true;
                    tasteSelect.parentNode.parentNode.style.display = 'block';

                    for (let i = 0; i < tastes.length; i++) {
                        const option = document.createElement('option');
                        if (i === 0) {
                            option.value = '';
                        } else {
                            option.value = tastes[i];
                        }
                        option.text = tastes[i];
                        tasteSelect.appendChild(option);
                    }
                } else {
                    tasteSelect.required = false;
                    tasteSelect.parentNode.parentNode.style.display = 'none';
                }

                const amountSelect = document.querySelector('.js-request__product-amount');
                if (response.amount && response.amount.length) {
                    const amount = response.amount;
                    removeOptions(amountSelect);
                    amountSelect.required = true;
                    amountSelect.parentNode.parentNode.style.display = 'block';

                    for (let i = 0; i < amount.length; i++) {
                        const option = document.createElement('option');
                        if (i === 0) {
                            option.value = '';
                        } else {
                            option.value = amount[i];
                        }
                        option.text = amount[i];
                        amountSelect.appendChild(option);
                    }
                } else {
                    amountSelect.required = false;
                    amountSelect.parentNode.parentNode.style.display = 'none';
                }

                if (response.tool) {
                    document.querySelector('.js-request-modal-h2').innerHTML =
                        document.querySelector('.js-request-modal-h2').dataset.tool;

                    document.querySelector('.js-request__product-amount-label').innerHTML =
                        document.querySelector('.js-request__product-amount-label').dataset.tool;

                    document.querySelector('.js-request__product-amount').getElementsByTagName('option')[0].innerHTML =
                        document.querySelector('.js-request__product-amount').dataset.tool;

                    document.querySelector('.js-request__product-flavour-label').innerHTML =
                        document.querySelector('.js-request__product-flavour-label').dataset.tool;

                    document.querySelector('.js-request__product-flavour').getElementsByTagName('option')[0].innerText =
                        document.querySelector('.js-request__product-flavour').dataset.tool;
                } else {
                    document.querySelector('.js-request-modal-h2').innerHTML =
                        document.querySelector('.js-request-modal-h2').dataset.sample;

                    document.querySelector('.js-request__product-amount-label').innerHTML =
                        document.querySelector('.js-request__product-amount-label').dataset.sample;

                    document.querySelector('.js-request__product-amount').getElementsByTagName('option')[0].innerHTML =
                        document.querySelector('.js-request__product-amount').dataset.sample;

                    document.querySelector('.js-request__product-flavour-label').innerHTML =
                        document.querySelector('.js-request__product-flavour-label').dataset.sample;

                    document.querySelector('.js-request__product-flavour').getElementsByTagName('option')[0].innerText =
                        document.querySelector('.js-request__product-flavour').dataset.sample;
                }
            }
        };
        request.send();

        openRequestModal(productName, productType, productId);
    });
}

function removeOptions(selectElement) {
    for (let i = selectElement.options.length; i >= 0; i--) {
        selectElement.remove(i);
    }
}

const btnsSendModal = document.querySelectorAll('.js-request__btn-send');

if (btnsSendModal.length > 0) {
    btnsSendModal.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openRequestModal();
            document.querySelector('.js-request__btn-send-aside').style.display = 'none';
            document.querySelector('.js-request-error-message').style.display = 'none';
            document.querySelector('.js-request-modal').style.display = 'none';
            document.querySelector('.js-request-send-modal').style.display = 'block';
            document.querySelector('.js-request-added-modal').style.display = 'none';
            document.querySelector('.js-request-success-modal').style.display = 'none';
        });
    });
}

const btnAddSameProduct = document.querySelector('.js-product__btn-request-same-product');
if (btnAddSameProduct) {
    btnAddSameProduct.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector('.js-request__btn-send-aside').style.display = 'none';
        document.querySelector('.js-request-added-modal').style.display = 'none';
        document.querySelector('.js-request-modal').style.display = 'block';
    });
}

const btnProductSubmit = document.querySelector('.js-request__btn-submit');
if (btnProductSubmit) {
    btnProductSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        const requestForm = document.querySelector('.js-request-products-submit');
        if (!requestForm.reportValidity()) {
            return false;
        }

        document.querySelector('.js-request-error-message').style.display = 'none';
        document.querySelector('.js-request-response-message').style.display = 'none';

        // Do request
        const requestAjax = new XMLHttpRequest();
        const postData = new FormData();
        postData.append('name', requestForm.querySelector('#name').value);
        postData.append('street', requestForm.querySelector('#street').value);
        postData.append('housenr', requestForm.querySelector('#housenr').value);
        postData.append('zipcode', requestForm.querySelector('#zipcode').value);
        postData.append('city', requestForm.querySelector('#city').value);
        postData.append('email', requestForm.querySelector('#email').value);
        postData.append('code', requestForm.querySelector('#code').value);
        requestAjax.open(
            'POST',
            laroute.route('site.request.submit'), // eslint-disable-line no-undef
            true
        );
        requestAjax.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                const response = JSON.parse(this.response);
                if (response.success) {
                    document.querySelector('.js-request-send-modal').style.display = 'none';
                    document.querySelector('.js-request-success-modal').style.display = 'block';
                } else {
                    if (response.message) {
                        document.querySelector('.js-request-response-message').style.display = 'block';
                        document.querySelector('.js-request-response-message').innerHTML = response.message;
                    } else {
                        document.querySelector('.js-request-error-message').style.display = 'block';
                    }
                }
            }
        };
        requestAjax.send(postData);
    });
}

const showDeliveryInputs = document.querySelector('.js-show-delivery-inputs');
if (showDeliveryInputs) {
    showDeliveryInputs.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.js-change-delivery').style.display = 'block';
        showDeliveryInputs.style.display = 'none';
    });
}

const btnAddProduct = document.querySelector('.js-request__product-add');

if (btnAddProduct) {
    btnAddProduct.addEventListener('click', (e) => {
        e.preventDefault();
        getProductInfo();
    });
}

const productInfoBtns = document.querySelectorAll('.js-get-product-info');

if (productInfoBtns.length > 0) {
    productInfoBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            // Do request
            const request = new XMLHttpRequest();
            request.open(
                'GET',
                laroute.route( // eslint-disable-line no-undef
                    'site.request.products.get',
                    { product: btn.dataset.productId }
                ),
                true
            );
            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    const response = JSON.parse(this.response);
                    const overlay = document.querySelector('.js-overlay');
                    const modal = document.querySelector('.js-product-info-modal');

                    const topPosition = (window.pageYOffset || document.documentElement.scrollTop);

                    modal.style.top = topPosition + 'px';

                    overlay.classList.add('c-overlay--active');
                    modal.classList.add('c-request--active');

                    modal.querySelector('.js-content-wrapper').innerHTML = response.info;
                }
            };
            request.send();
        });
    });
}

const btnsRemoveProduct = document.querySelectorAll('.js-request__product-remove');

if (btnsRemoveProduct) {
    btnsRemoveProduct.forEach((btn) => {
        deleteProductClick(btn);
    });
}

function deleteProductClick(btn) {
    btn.addEventListener('click', (e) => {
        e.preventDefault();

        // Do request
        const request = new XMLHttpRequest();
        request.open(
            'POST',
            laroute.route('site.request.products.delete', {// eslint-disable-line no-undef
                requestProduct: btn.dataset.requestProductId
            }),
            true
        );
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                const response = JSON.parse(this.response);
                if (response.success) {
                    const basketListDataType = btn.parentNode.parentNode.parentNode.dataset.type;
                    const products = document.querySelectorAll(`
                        .js-request__list [data-id="${btn.dataset.requestProductId}"]`
                    );
                    if (products) {
                        products.forEach((product) => {
                            product.remove();
                        });
                    }

                    const basketList = document.querySelectorAll(`ul[data-type="${basketListDataType}"]`);
                    if (basketList) {
                        basketList.forEach((list) => {
                            const basketListItems = list.querySelectorAll('li');

                            if (
                                basketListItems.length == 1 &&
                                basketListItems[0].classList.contains('js-empty-basket')
                            ) {
                                basketListItems[0].style.display = 'block';
                            }
                        });
                    }

                    const codeFieldWrapper = document.querySelector('.js-product-code');
                    if (response.showCodeField) {
                        codeFieldWrapper.style.display = 'block';
                        codeFieldWrapper.querySelector('input').required = true;
                    } else {
                        codeFieldWrapper.style.display = 'none';
                        codeFieldWrapper.querySelector('input').required = false;
                    }
                }
            }
        };
        request.send();
    });
}

/**
 * @description - get product info
 */

function getProductInfo() {
    const productForm = document.querySelector('.js-product-form');
    const request = document.querySelector('.js-request');
    if (!productForm.reportValidity()) {
        return false;
    }

    document.querySelector('.js-product-add-response-message').style.display = 'none';

    const product = {
        id: request.dataset.productId,
        name: request.querySelector('.js-request__product-name').innerHTML,
        amount: request.querySelector('.js-request__product-amount').value,
        type: request.dataset.productType,
        flavour: null
    };

    if (
        request.querySelector('.js-request__product-flavour') && request
            .querySelector('.js-request__product-flavour').hasAttribute('required')
    ) {
        product.flavour = request.querySelector('.js-request__product-flavour').value;
    }

    // Do request
    const requestAjax = new XMLHttpRequest();
    const postData = new FormData();
    if (product.flavour) {
        postData.append('taste', product.flavour);
    }
    postData.append('amount', product.amount);
    requestAjax.open(
        'POST',
        laroute.route('site.request.products.add', {// eslint-disable-line no-undef
            product: product.id
        }),
        true
    );
    requestAjax.onload = function() {
        if (this.status >= 200 && this.status < 400) {
            const response = JSON.parse(this.response);
            if (response.success) {
                if (response.amount) {
                    updateListAmount(response.requestProductId, response.amount);
                } else {
                    addToList(product, response.requestProductId);
                }
                showProductAddedModal(response.relatedProducts);
            }

            if (response.message) {
                document.querySelector('.js-product-add-response-message').style.display = 'block';
                document.querySelector('.js-product-add-response-message').innerHTML = response.message;
            }

            const codeFieldWrapper = document.querySelector('.js-product-code');
            if (response.showCodeField) {
                codeFieldWrapper.style.display = 'block';
                codeFieldWrapper.querySelector('input').required = true;
            } else {
                codeFieldWrapper.style.display = 'none';
                codeFieldWrapper.querySelector('input').required = false;
            }
        }
    };
    requestAjax.send(postData);
}

function showProductAddedModal(relatedProducts) {
    document.querySelector('.js-request__btn-send-aside').style.display = 'block';
    document.querySelector('.js-related-products-wrapper').style.display = 'none';
    document.querySelector('.js-request-modal').style.display = 'none';
    document.querySelector('.js-request-send-modal').style.display = 'none';
    document.querySelector('.js-request-success-modal').style.display = 'none';
    document.querySelector('.js-request-added-modal').style.display = 'block';
    if (relatedProducts && relatedProducts.length) {
        document.querySelector('.js-related-products-wrapper').style.display = 'block';
        const relatedProductsList = document.querySelector('.js-related-products');
        relatedProductsList.innerHTML = '';
        relatedProducts.forEach((product) => {
            const productItem = document.createElement('div');
            productItem.className = 'c-request__other-product js-product';
            productItem.dataset.productName = product.title;
            productItem.dataset.productId = product.product_id;
            productItem.dataset.productType = product.type;

            let productImage = '';
            if (product.image) {
                productImage = `
                    <figure class="c-request__other-product-figure">
                        <img src="${product.image}" class="c-request__other-product-img">
                    </figure>
                `;
            }

            const productHtml = productImage + `
                <div class="c-request__other-product-info">
                    <h3 class="c-request__other-product-heading">${product.title}</h3>
                    ${product.intro}
                    <button class="c-btn js-product__btn-request">${window.translations.addToRequest}</button>
                </div>
            `;

            productItem.innerHTML = productHtml;

            const btnAdd = productItem.querySelector('.js-product__btn-request');
            addProductClick(btnAdd);

            relatedProductsList.appendChild(productItem);
        });
    }
}

function updateListAmount(productId, amount) {
    const products = document.querySelectorAll(`li[data-id="${productId}"]`);
    if (products) {
        products.forEach((product) => {
            product.querySelector('.js-product-amount').innerHTML = `${amount}x`;
        });
    }
}

function addToList(product, requestProductId) {
    const requestLists = document.querySelectorAll('.js-request__list');

    requestLists.forEach((list) => {
        const productItem = document.createElement('li');
        productItem.className = 'c-products__aside-cat-list-item';
        productItem.dataset.id = requestProductId;

        let productHtml = `
            <div class="c-products__aside-cat-list-item-amount js-product-amount">
                ${product.amount}x
            </div>
            <div class="c-products__aside-cat-list-item-info">
                ${product.name}`;

        if (product.flavour !== null) {
            productHtml += `<span>${ product.flavour}</span>`;
        }

        productHtml += `</div>
            <div class="c-products__aside-cat-list-item-actions">
                <a href="#" class="js-request__product-remove"
                data-request-product-id="${requestProductId}">${window.translations.delete}</a>
            </div>`;

        productItem.innerHTML = productHtml;

        const btnRemove = productItem.querySelector('.js-request__product-remove');
        deleteProductClick(btnRemove);

        const catList = list.querySelector(`.js-request__cat-list[data-type=${product.type}]`);
        const emptyBaskterHolder = list.querySelector(`
            .js-request__cat-list[data-type=${product.type}] .js-empty-basket
        `);
        if (emptyBaskterHolder) {
            emptyBaskterHolder.style.display = 'none';
        }
        catList.appendChild(productItem);
    });
}
